/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {Input, InputGroup, InputGroupAddon} from "reactstrap";
import {i18n} from "../../language/i18n";
import HearFacebookButtons from "./HearFacebookButtons";
import HearFacebookButton from "./HearFacebookButton";
import isURL from "../../utils/isURL";
import checkImg from "../../utils/checkImg";

class HearFacebookGeneric extends Component {

    constructor(props) {
        super(props);

        const {replyData} = this.props;

        let elements = replyData.elements === undefined ? {} : replyData.elements;
        this.element = elements[0] === undefined ? {} : elements[0];

        let actionUrl;
        if (this.element.default_action === undefined || this.element.default_action.url === undefined) {
            actionUrl = "";
        } else {
            actionUrl = this.element.default_action.url;
        }

        let imageUrl = this.element.url === undefined ? "" : this.element.url;
        let text = this.element.text === undefined ? "" : this.element.text;
        let subtitle = this.element.subtitle === undefined ? "" : this.element.subtitle;
        let buttons = this.element.buttons === undefined ? [] : this.element.buttons;

        imageUrl = imageUrl === null ? "" : imageUrl;
        text = text === null ? "" : text;
        subtitle = subtitle === null ? "" : subtitle;
        buttons = buttons === null ? [] : buttons;
        actionUrl = actionUrl === null ? [] : actionUrl;

        this.state = {
            replyData: replyData,
            text: text,
            subtitle: subtitle,
            url: imageUrl,
            default_action_url: actionUrl,
            buttons: buttons,

            buttonUrlValid: false,
            buttonUrlInvalid: false,

            buttonActionUrlValid: false,
            buttonActionUrlInvalid: false,
        };

    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.receiveElements(nextProps);
    }

    receiveElements(nextProps) {
        let replyData = nextProps.replyData;

        let elements = replyData.elements === undefined ? {} : replyData.elements;
        this.element = elements[0] === undefined ? {} : elements[0];

        let actionUrl;
        if (this.element.default_action === undefined || this.element.default_action.url === undefined) {
            actionUrl = "";
        } else {
            actionUrl = this.element.default_action.url;
        }

        let imageUrl = this.element.url === undefined ? "" : this.element.url;
        let text = this.element.text === undefined ? "" : this.element.text;
        let subtitle = this.element.subtitle === undefined ? "" : this.element.subtitle;
        let buttons = this.element.buttons === undefined ? [] : this.element.buttons;

        imageUrl = imageUrl === null ? "" : imageUrl;
        text = text === null ? "" : text;
        subtitle = subtitle === null ? "" : subtitle;
        buttons = buttons === null ? [] : buttons;
        actionUrl = actionUrl === null ? [] : actionUrl;

        this.setState({
            replyData: replyData,
            text: text,
            subtitle: subtitle,
            url: imageUrl,
            default_action_url: actionUrl,
            buttons: buttons,
        });
    }

    updateReply(index, key, value) {
        const {hearReplies, replyIndex} = this.props;
        this.element.buttons = value;

        hearReplies.updateReply(replyIndex, "elements", [this.element]);
    }

    handleTitleChange = (event) => {
        const {hearReplies, replyIndex} = this.props;
        this.element.text = event.target.value;

        this.setState({text: event.target.value});

        hearReplies.updateReply(replyIndex, "elements", [this.element]);
    };

    handleSubTitleChange = (event) => {
        const {hearReplies, replyIndex} = this.props;
        this.element.subtitle = event.target.value;

        this.setState({subtitle: event.target.value});

        hearReplies.updateReply(replyIndex, "elements", [this.element]);
    };

    handleUrlChange = (event) => {
        const {hearReplies, replyIndex} = this.props;
        this.element.url = event.target.value;

        let url = event.target.value;
        if (url === "") {
            delete this.element.url;
        } else {
            this.element.url = url;
        }

        this.setState({url: event.target.value});

        let checkURL = checkImg(event.target.value);

        if (checkURL) {
            this.setState({buttonUrlValid: true, buttonUrlInvalid: false});
            hearReplies.updateReply(replyIndex, "elements", [this.element]);
        } else {
            this.setState({buttonUrlValid: false, buttonUrlInvalid: true});
        }
    };

    handleActionChange = (event) => {
        const {hearReplies, replyIndex} = this.props;

        let actionUrl = event.target.value;
        if (actionUrl === "") {
            delete this.element.default_action;
        } else {
            let action = {};
            action.type = HearFacebookButton.WEB_LINK;
            action.url = actionUrl;
            action.messenger_extensions = false;
            action.webview_height_ratio = "FULL";
            this.element.default_action = action;
        }

        this.setState({default_action_url: actionUrl});

        if (isURL(actionUrl)) {
            this.setState({buttonActionUrlValid: true, buttonActionUrlInvalid: false});
            hearReplies.updateReply(replyIndex, "elements", [this.element]);
        } else {
            this.setState({buttonActionUrlValid: false, buttonActionUrlInvalid: true});
        }
    };

    render() {
        return (
            <div className="hear-element hear-facebook-generic">

                <div className="api-input-item">
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">{i18n.t("Title")}</InputGroupAddon>
                        <Input
                            id={'generic-title-input-' + this.props.replyIndex}
                            onChange={this.handleTitleChange}
                            value={this.state.text}/>
                    </InputGroup>
                    <small className="form-text text-muted">
                        <b className="text-danger">{i18n.t("Required.")}</b>&nbsp;
                        {i18n.t("The title to display in the template. 80 characters limit.")}
                    </small>
                </div>

                <div className="api-input-item">
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">{i18n.t("Subtitle")}</InputGroupAddon>
                        <Input
                            id={'generic-subtitle-input-' + this.props.replyIndex}
                            onChange={this.handleSubTitleChange}
                            value={this.state.subtitle}/>
                    </InputGroup>
                    <small className="form-text text-muted">
                        <b>{i18n.t("Optional.")}</b> {i18n.t("The subtitle to display in the template. 80 characters limit.")}
                    </small>
                </div>

                <div className="api-input-item">
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">{i18n.t("Image URL")}</InputGroupAddon>
                        <Input
                            id={'generic-image-url-input-' + this.props.replyIndex}
                            type="URL"
                            placeholder="https://..."
                            onChange={this.handleUrlChange}
                            value={this.state.url}
                            invalid={this.state.buttonUrlInvalid}
                            valid={this.state.buttonUrlValid}
                        />
                    </InputGroup>
                    <small className="form-text text-muted">
                        <b>{i18n.t("Optional.")}</b> {i18n.t("The URL of the image to display in the template.")}
                    </small>
                </div>

                <div className="api-input-item">
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">{i18n.t("Action URL")}</InputGroupAddon>
                        <Input
                            type="URL"
                            id={'generic-action-url-input-' + this.props.replyIndex}
                            placeholder="https://..."
                            onChange={this.handleActionChange}
                            value={this.state.default_action_url}
                            invalid={this.state.buttonActionUrlInvalid}
                            valid={this.state.buttonActionUrlValid}
                        />
                    </InputGroup>
                    <small className="form-text text-muted">
                        <b>{i18n.t("Optional.")}</b> {i18n.t("The link will open when the image is clicked.")}
                    </small>
                </div>
                <hr width="50%"/>

                <HearFacebookButtons
                    replyIndex={this.props.replyIndex}
                    buttonsHolder={this}
                    genericButton={true}
                    fanpageId={this.props.fanpageId}
                    hearId={this.props.hearId}
                    hearReplies={this.props.hearReplies}
                    replyData={this.state.replyData}
                    buttonsData={this.state.buttons}
                />
            </div>
        );
    }
}


export default HearFacebookGeneric;

